import React, {useRef} from 'react'
import { graphql } from 'gatsby'
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import useAccordionAnimation from "../../../hooks/use-accordion-animation"
import gsap from "gsap"

const ServiceExpertise = ({title, richContent, services}) => {
  const accordionRef = useRef(null);

  const handleAccordionClick = (index) => {
    const accordionElement = accordionRef.current;
    const contentElement = accordionElement.querySelectorAll('.service-expertise__item--content')[index];
    const contentTitle = accordionElement.querySelectorAll('.service-expertise__item--title')[index];
    const contentWrapper = contentElement.querySelector('.content');

    contentElement.classList.toggle('active');
    contentTitle.classList.toggle('active');

    if (contentElement.classList.contains('active')) {
      gsap.to(contentElement, { height: contentWrapper.scrollHeight + 40, duration: 0.3 });
    } else {
      gsap.to(contentElement, { height: 0, duration: 0.3 });
    }
  };

  return (
    <section id='our-expertise' className="service-expertise" ref={accordionRef}>
      <div className='service-expertise__inner'>
        <div className="service-expertise__wrapper">
          <div className="line line--vertical center-top"></div>

          <div className="service-expertise__left">
            {title && <h2>{parse(title)}</h2>}
            {richContent && <StructuredText data={richContent} />}
          </div>

          <div className="service-expertise__right">
            {
              services?.length > 0 &&
              <div className='service-expertise__items'>
                {services.map((el, i) => (
                  <div key={i} className='service-expertise__item' onClick={() => handleAccordionClick(i)}>
                    <div className='service-expertise__item--title'>
                      {el.title && <h3>{parse(el.title)}</h3>}
                      <div className='icon'></div>
                    </div>

                    <div className='service-expertise__item--content' style={{ height: 0, overflow: 'hidden' }}>
                      <div className='content'>
                        {el.richContent && <StructuredText data={el.richContent} />}
                        {el.items?.length > 0 &&
                          <ul>
                            {el.items.map((item, index) => (
                              <li key={index}>{item.title}</li>
                            ))}
                          </ul>
                        }
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServiceExpertise

export const query = graphql`
    fragment ServiceExpertiseProps on DatoCmsServiceExpertise {
      ... on DatoCmsServiceExpertise {
        id
        title
        richContent {
          value
        }
        services {
          richContent {
            value
          }
          title
          items {
            title
          }
        }
      }
    }
`;